<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  siteListMethod,
  batchListMethod,
  courseListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Course Batch',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      type: 'SELF_PACED',
      status: true,
      price: 0,
      liveStatus: true,
      userError: null,
      isUserError: false,
      isLoading: false,
      show: false,
      platformId: '',
      platform: '',
      collegeId: '',
      collegeName: '',
      teacherList: [],
      teacherDataList: [],
      batchList: [],
      timeError: false,
      statusList: [
        { text: 'True', value: true },
        { text: 'False', value: false },
      ],
      typeList: [
        { text: 'Self Paced', value: 'SELF_PACED' },
        { text: 'Instructor Led', value: 'INSTRUCTOR_LED' },
      ],
      trainerId: null,
      trainerList: [],
    }
  },
  computed: {
    ...authComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getTrainerList()
    let courseId = this.$route.params.courseId
    this.fetchCourseById({ courseId }).then((courseInfo) => {
      this.platformId = courseInfo.platform_id[0]
      this.platform = courseInfo.platform[0]
    })
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    ...batchListMethod,
    ...courseListMethod,

    getTrainerList() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchTrainerList({ filter })
        .then((trainerList) => {
          this.isLoading = false
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Trainer',
            disabled: true,
          })
          trainerList.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            listitems.push(ele)
          })
          this.trainerList = listitems
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    addMeetingData() {
      this.timeError = false
      this.isLoading = true
      const Data = {
        course_id: this.$route.params.courseId,
        price: this.price,
        live_status: this.liveStatus,
        type: this.type,
        status: this.status,
        trainer_id: this.trainerId,
        platform: this.platform,
        platform_id: this.platformId,
      }
      this.addCoursebatch({ Data })
        .then((resp) => {
          this.isLoading = false
          this.$router.push({ name: 'course.list' })
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.userError = getError.message
          this.isUserError = true
        })
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
    selectTeacher() {
      this.teacherList = []
      this.teacherId = null
      var i = 0
      this.teacherList.push({
        value: null,
        text: 'Select Teacher',
        disabled: true,
      })
      for (i = 0; i < this.teacherDataList.length; i++) {
        if (this.teacherDataList[i].batch === this.batchId) {
          this.teacherList.push({
            value: this.teacherDataList[i].value,
            text: this.teacherDataList[i].text,
          })
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isUserError"
              variant="danger"
              v-html="userError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addMeetingData"
            >
              <b-form-group label="Course Price*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="price"
                  type="number"
                  placeholder="Enter Price"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Select Live Status*" label-for="input-1">
                <b-form-select
                  v-model="liveStatus"
                  :options="statusList"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Type*" label-for="input-1">
                <b-form-select
                  v-model="type"
                  :options="typeList"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Status*" label-for="input-1">
                <b-form-select
                  v-model="status"
                  :options="statusList"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Trainer*" label-for="input-1">
                <b-form-select
                  v-model="trainerId"
                  :options="trainerList"
                ></b-form-select>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color:white;"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/course-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
